document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.getElementById('LunaraNav');
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    if (nav) nav.classList.toggle('is-open', !open);
  }

  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const wrapper = event.target.closest('.ln-quantity');
    const input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    const value = Number(input.value) || 1;
    input.value = String(minus ? Math.max(1, value - 1) : value + 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const thumb = event.target.closest('[data-gallery-src]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery && gallery.querySelector('[data-gallery-main]');
    if (main) {
      main.src = thumb.getAttribute('data-gallery-src');
      main.alt = thumb.getAttribute('data-gallery-alt') || '';
      gallery.querySelectorAll('[data-gallery-src]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
    }
  }
});
